import { createFileRoute } from '@tanstack/react-router';
import { GALLERY } from 'features/Landing/content';
import { CARD_PHOTO_SIZES, Photo } from 'features/Landing/Photo';
import { Container, CtaBand } from 'features/Landing/primitives';
import { type FC } from 'react';
import { breadcrumbJsonLd, buildHead } from 'seo/head';

const ProjectsPage: FC = () => (
  <>
    <section className="bg-ink-900 pt-32 pb-16 sm:pt-40 sm:pb-20">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8">
        <p className="font-mono text-xs tracking-[0.25em] text-brand-400 uppercase">
          Our work - Hamilton &amp; Waikato
        </p>
        <h1 className="font-display mt-4 max-w-3xl text-4xl leading-tight font-bold text-white sm:text-5xl">
          Concrete we&rsquo;re happy to put our name on
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink-300 sm:text-lg">
          Foundations, driveways, patios and finished sections from around the Waikato. Every photo
          is our own crew&rsquo;s work.
        </p>
      </div>
    </section>

    <section className="py-16 sm:py-24">
      <Container>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {GALLERY.map((item) => (
            <figure
              key={item.label}
              className="group overflow-hidden rounded-lg border border-ink-200 bg-white"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <Photo
                  photo={item.image}
                  alt={item.alt}
                  sizes={CARD_PHOTO_SIZES}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                />
              </div>
              <figcaption className="px-4 py-3 font-mono text-xs tracking-wide text-ink-600 uppercase">
                {item.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </Container>
    </section>

    <CtaBand title="Picture your job here?" />
  </>
);

export const Route = createFileRoute('/_landing/projects')({
  head: () =>
    buildHead({
      title: 'Our Work | Concrete Projects in Hamilton & Waikato – Dreams Built',
      description:
        'See recent Dreams Built projects: residential foundations, exposed-aggregate driveways, patios, fencing and landscaping across Hamilton and the Waikato.',
      path: '/projects',
      jsonLd: [
        breadcrumbJsonLd([
          { name: 'Home', path: '/' },
          { name: 'Our work', path: '/projects' }
        ])
      ]
    }),
  component: ProjectsPage
});
